import { useNavigate } from "react-router-dom";

import { PublicLabgram } from "api/public/labgrams/labgrams.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { labgramColumns } from "./Labgrams.columns";

interface LabgramsTableProps {
  title: string;
  rows: PublicLabgram[];
  loading: boolean;
}

const LabgramsTable = ({ title, rows, loading }: LabgramsTableProps) => {
  const navigate = useNavigate();
  return (
    <DefaultDataGrid
      loading={loading}
      getRowId={(row) => row.labgram_id}
      columns={labgramColumns}
      rows={rows}
      onRowClick={({ row }) => {
        navigate(`${row.labgram_id}`);
      }}
      clickableRow
      disableCellFocus
      title={title}
      // HACK: - similar issue on Public TD table, and related one on PCL table
      // This is a deprecated property, but without it in place
      // this table will constantly resize under mysterious circumstances
      // that we have not been able to identify yet.
      // It occurs on Eric's laptop at home, and not in the office
      // specifically with the dataset from dev, over 100 rows present,
      // and multiple rows that reflow when the width changes
      // when the parent container is something like the Accordion Details component.
      // We have ruled out browser, and machine, and os as the culprits
      // we have only been able to reproduce on Eric's mac, Sazhelle's Windows
      // and one end user's machine so far.
      // Further investigation may be required to identify the actual issue, but
      // this is a rabbit hole and this solution works for now.
      autoHeight
    />
  );
};

export default LabgramsTable;
